"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlActiveMembershipsSerialization = void 0;
const MembershipTransactionSerialization_1 = require("./MembershipTransactionSerialization");
class PaymentTerminalControlActiveMembershipsSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.memberships = entity.memberships?.map((field) => field
            ? JSON.parse(MembershipTransactionSerialization_1.MembershipTransactionSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.memberships = entity.memberships?.map((field) => field
            ? MembershipTransactionSerialization_1.MembershipTransactionSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.PaymentTerminalControlActiveMembershipsSerialization = PaymentTerminalControlActiveMembershipsSerialization;
